import type { ReactNode } from 'react';
import { Modal } from 'antd';
import { useT } from '../locales';

interface ConfirmDeleteModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  title: string;
  message: string;
  /**
   * Label of the OK button. Defaults to common.delete so the legacy
   * delete-style confirms keep their wording; state-change confirms
   * (dar de baja / reactivar) pass their own label.
   */
  okText?: string;
  /**
   * Whether the OK button renders as a destructive (danger) action.
   * Defaults to true — the historical behavior of this confirm.
   */
  okDanger?: boolean;
  /** Optional content rendered below the message (e.g. a radio group). */
  children?: ReactNode;
}

export function ConfirmDeleteModal({
  open,
  onConfirm,
  onCancel,
  loading,
  title,
  message,
  okText,
  okDanger = true,
  children,
}: ConfirmDeleteModalProps) {
  const t = useT();
  return (
    <Modal
      title={title}
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={loading}
      okText={okText ?? t('common.delete')}
      okButtonProps={{ danger: okDanger }}
    >
      <p>{message}</p>
      {children}
    </Modal>
  );
}
